import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-navmenu',
  standalone: true,
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.scss'],
  imports: [
    RouterModule,
    CommonModule
  ],
})
export class NavmenuComponent {
  isLoggedIn: boolean = false;
  menuOpen: boolean = false;

  constructor(private AuthService: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.isLoggedIn = this.AuthService.isLoggedIn();
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  logout(): void {
    this.AuthService.logout();
    this.router.navigate(['/login']);
  }
}
